//

export const SET_SELECTED_ELEMENT = '@@affectli/form/SET_SELECTED_ELEMENT';

export const setSelectedElement = selectedElement => (dispatch, getState) => {
    dispatch({ type: SET_SELECTED_ELEMENT, payload: selectedElement });
};
